import { render, staticRenderFns } from "./YogaProgramPhone.vue?vue&type=template&id=426e98f3&scoped=true&"
import script from "./YogaProgramPhone.vue?vue&type=script&lang=js&"
export * from "./YogaProgramPhone.vue?vue&type=script&lang=js&"
import style0 from "./YogaProgramPhone.vue?vue&type=style&index=0&id=426e98f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426e98f3",
  null
  
)

export default component.exports